import { apiStatusError, fetchError } from '../errors';
import { API_LOCATION, API_LOCATION_WITH_SLOTS } from 'FRONTEND/utils/routes';

export const formatLocation = (rawLocation) => {
  const data = rawLocation.resource || rawLocation;
  const stationExt = data.extension?.find((ext) => ext.id === 'StationId');
  const tenantId = data.extension?.find((ext) => ext.id === 'TenantId');
  return {
    id: data.id,
    station_id: stationExt?.valueString,
    description: data.description,
    address: data.address,
    status: data.status,
    display: data.description + ' ' + data.address?.city,
    tenantId: tenantId?.valueString,
  };
};


export const getLocations = async() => {
  try {
    const response = await fetch(`${API_LOCATION}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });

    return response.entry.map(formatLocation);
  } catch (error) {
    throw fetchError({ error });
  }
};

export const getLocationsWithSlots = async(ignoreManagementRight = false) => {
  try {
    const response = await fetch(`${API_LOCATION_WITH_SLOTS}?ignore_management_right=${ignoreManagementRight}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });

    return response.entry.map(formatLocation);
  } catch (error) {
    throw fetchError({ error });
  }
};


export const createLocation = async({ description, address, resourceId }) => {
  try {
    const body = locationBody({ description, city: address, resourceId });
    const response = await fetch(`${API_LOCATION}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': window.CSRFToken,
      },
      body: JSON.stringify(body),
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });

    console.log('createLocation response', response);
    return formatLocation(response);
  } catch (error) {
    throw fetchError({ error });
  }
};

export const deleteLocation = async({ locationId }) => {
  try {
    const response = await fetch(`${API_LOCATION}${locationId}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': window.CSRFToken,
      },
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });

    return response;
  } catch (error) {
    throw fetchError({ error });
  }
};

export const updateLocation = async({ location }) => {
  const { description, address, id, station_id } = location;
  const body = locationBody({ description, city: address.city, resourceId: station_id, id });
  try {
    const response = await fetch(`${API_LOCATION}${id}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': window.CSRFToken,
      },
      body: JSON.stringify(body),
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });
    return formatLocation(response);
  } catch (error) {
    throw fetchError({ error });
  }
};


const locationBody = ({ resourceId, city, description, id }) => {
  return {
    id,
    resourceType: 'Location',
    description,
    address: {
      city,
    },
    type: 'COMM',
    extension: [
      {
        id: 'StationId',
        valueString: resourceId,
      },
    ],
  };
};
